import styled from 'styled-components';
import TopPageLinks from '@/components/TopPageLinks';

export const Navigation = styled(TopPageLinks)`
  padding: 22.5px 0;
  margin-top: -26px;
  margin-left: -20px;
  margin-right: -20px;
  position: sticky;
  top: -26px;
  border-bottom: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  background-color: ${({ theme }) => theme.colors['neutral-20']};
  z-index: 2;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-left: -100px;
    margin-right: -100px;
    padding-left: 100px;
    padding-right: 100px;
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors['neutral-0']};
  padding: 24px 32px;
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.07);
`;
